import { useEffect } from "react";

import { isEqual, omit } from "lodash";

import { getInitialValues } from "./getInitialValues";

export const useDetectChanges = ({ values, hasChanges, setHasChanges, lawyers }) => {
  const sanityId = values?.sanityId || "";

  useEffect(() => {
    if (!sanityId || sanityId === "non-sanity") return;

    const lawyer = lawyers.find((lawyer) => lawyer._id === sanityId);

    if (!lawyer) return;

    const formValues = omit(values, "isSelfRepresented");
    const lawyerValues = omit(getInitialValues(lawyer), "isSelfRepresented");

    const changed = !isEqual(formValues, lawyerValues);

    if (changed && !hasChanges) {
      setHasChanges(true);
    }

    if (!changed && hasChanges) {
      setHasChanges(false);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sanityId, lawyers, values]);
};
